import { TimeResolution } from '@vi-iot/client';

export const PATTERN = {
  PHONE: /^([\+])[ 0-9\.\(\)\-\/]*$/im,
  NO_SPACES: /^$|.*\S+.*/,
  // https://blog.mailtrap.io/angular-email-validation/
  EMAIL: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$',
};

export const MS_TIME: Partial<{ [key in TimeResolution]: number }> = {
  '1d': 86400000,
  '1h': 3600000,
  '5m': 300000,
  '1m': 60000,
};

export const PLANT_OVERVIEW_COUNTRIES = [
  'DE',
  'FR',
  'AT',
  'NL',
  'BE',
  'LU',
  'ES',
  'IT',
  'CA',
  'US',
  'SK',
  'CZ',
  'RO',
  'TR',
  'SI',
  'HR',
  'BA',
  'RS',
  'UA',
  'LT',
  'EE',
  'LV',
  'HU',
  'BG',
  'DK',
  'CH',
  'FI',
  'SE',
];

export const wifiSignalThreshold = -67;
export const lowLqiSignalThreshold = 30;
export const lowBatteryThreshold = 30;
export const criticalBatteryThreshold = 10;
export const weeksBeforeTrialPackageEndsAlertShouldBeShown = 2;
export const weeksBeforeContingentPackageExpireAlertShouldBeShown = 6;
export const weeksBeforeVoucherNAPackageExpireAlertShouldBeShown = 4;
export const viessmannShop = 'https://shop.viessmann-climatesolutions.com/';
export const VITOTRONIC_200_DOCUMENT_ID = '5832377';
export const ordinalSuffixes: string[] = ['th', 'st', 'nd', 'rd'];
